/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';

import {
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Typography,
  useTheme,
} from '@material-ui/core';
import { Chat, Description, ExpandLess, ExpandMore, Report } from '@material-ui/icons';

import { useBudget } from '../../context/BudgetContext';
import { useStyles } from './styles';

export default function Observations() {
  const classes = useStyles();
  const theme = useTheme();

  const {
    budget: {
      client: { complaints, observations },
      repair: { report },
    },
  } = useBudget();

  const [expandedComplaints, setExpandedComplaints] = useState(() => {
    const saved = localStorage.getItem('budgetComplaintsExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [expandedObservations, setExpandedObservations] = useState(() => {
    const saved = localStorage.getItem('budgetObservationsExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [expandedReport, setExpandedReport] = useState(() => {
    const saved = localStorage.getItem('budgetReportExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem('budgetComplaintsExpanded', JSON.stringify(expandedComplaints));
  }, [expandedComplaints]);

  useEffect(() => {
    localStorage.setItem('budgetObservationsExpanded', JSON.stringify(expandedObservations));
  }, [expandedObservations]);

  useEffect(() => {
    localStorage.setItem('budgetReportExpanded', JSON.stringify(expandedReport));
  }, [expandedReport]);

  const InfoSection = ({ icon: Icon, title, content, placeholder, expanded, setExpanded }) => (
    <Card className={classes.card}>
      <CardContent>
        <Box
          className={classes.header}
          style={{ cursor: 'pointer' }}
          onClick={() => setExpanded(!expanded)}
        >
          <Box display='flex' alignItems='center'>
            <Icon className={classes.icon} />
            <Typography variant='h6' className={classes.title}>
              {title}
            </Typography>
          </Box>
          <IconButton size='small'>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </Box>

        <Collapse in={expanded}>
          <Box
            sx={{
              backgroundColor: theme.palette.grey[50],
              padding: 2,
              borderRadius: 1,
              minHeight: 60,
              border: `1px solid ${theme.palette.grey[200]}`,
            }}
            style={{
              backgroundColor: theme.palette.grey[50],
              padding: 16,
              borderRadius: 8,
              minHeight: 60,
              border: `1px solid ${theme.palette.grey[200]}`,
            }}
          >
            <Typography
              variant='body2'
              style={{
                whiteSpace: 'pre-wrap',
                color: content ? theme.palette.text.primary : theme.palette.text.disabled,
              }}
            >
              {content || placeholder}
            </Typography>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );

  return (
    <Box>
      <InfoSection
        icon={Chat}
        title='Reclamação do Cliente'
        content={complaints}
        placeholder='Nenhuma reclamação registrada'
        expanded={expandedComplaints}
        setExpanded={setExpandedComplaints}
      />

      <InfoSection
        icon={Description}
        title='Observações'
        content={observations}
        placeholder='Nenhuma observação registrada'
        expanded={expandedObservations}
        setExpanded={setExpandedObservations}
      />

      <InfoSection
        icon={Report}
        title='Laudo'
        content={report}
        placeholder='Nenhum laudo registrado'
        expanded={expandedReport}
        setExpanded={setExpandedReport}
      />
    </Box>
  );
}
